var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import 'lodash/get';
import { createASTNode, findTargetNodeById, findTargetNodeByPath, isContainerNode, moveNodeByPath, } from '../../ast';
export var astInitialState = {
    id: 'root',
    type: 'container',
    cupName: 'root',
    attrs: {},
    children: [],
};
export var astSlice = createSlice({
    name: 'ast',
    initialState: astInitialState,
    reducers: {
        /**
         * Insert before ast node
         */
        insertBefore: function (state, action) {
            var _a = action.payload, targetPath = _a.targetPath, type = _a.type, nodeId = _a.nodeId, cupName = _a.cupName, _b = _a.attrs, attrs = _b === void 0 ? {} : _b;
            var findRes = findTargetNodeByPath(state, targetPath);
            if (findRes === false) {
                return;
            }
            var target = findRes.target, parent = findRes.parent, targetIndex = findRes.targetIndex;
            var newNode = createASTNode(type, nodeId, cupName, attrs);
            if (!target) {
                // cannot find target
                parent.children.push(newNode);
            }
            else {
                parent.children.splice(targetIndex, 0, newNode);
            }
        },
        /**
         * Insert after ast node
         */
        insertAfter: function (state, action) {
            var _a = action.payload, targetPath = _a.targetPath, type = _a.type, nodeId = _a.nodeId, cupName = _a.cupName, _b = _a.attrs, attrs = _b === void 0 ? {} : _b;
            var findRes = findTargetNodeByPath(state, targetPath);
            if (findRes === false) {
                return;
            }
            var target = findRes.target, parent = findRes.parent, targetIndex = findRes.targetIndex;
            var newNode = createASTNode(type, nodeId, cupName, attrs);
            if (!target) {
                // cannot find target
                parent.children.push(newNode);
            }
            else {
                parent.children.splice(targetIndex + 1, 0, newNode);
            }
        },
        appendChildren: function (state, action) {
            var _a = action.payload, targetPath = _a.targetPath, type = _a.type, nodeId = _a.nodeId, cupName = _a.cupName, _b = _a.attrs, attrs = _b === void 0 ? {} : _b;
            var findRes = findTargetNodeByPath(state, targetPath);
            if (findRes === false) {
                return;
            }
            var target = findRes.target;
            var newNode = createASTNode(type, nodeId, cupName, attrs);
            if (isContainerNode(target)) {
                target.children.push(newNode);
            }
            else {
                console.error('Target should be a container node');
                return;
            }
        },
        /**
         * remove node from tree by id
         */
        removeById: function (state, action) {
            var nodeId = action.payload.nodeId;
            var findRes = findTargetNodeById(state, nodeId);
            if (findRes === false) {
                return;
            }
            var parent = findRes.parent, targetIndex = findRes.targetIndex;
            parent.children.splice(targetIndex, 1);
        },
        /**
         * Move node by path
         */
        moveByPath: function (state, action) {
            var _a = action.payload, fromPath = _a.fromPath, toPath = _a.toPath;
            moveNodeByPath(state, fromPath, toPath);
        },
        /**
         * Set Node Attrs
         *
         * new attrs will append or override origin attrs
         */
        setNodeAttrs: function (state, action) {
            var _a = action.payload, nodeId = _a.nodeId, newAttrs = _a.newAttrs;
            var findRes = findTargetNodeById(state, nodeId);
            if (findRes === false) {
                return;
            }
            var target = findRes.target;
            target.attrs = __assign(__assign({}, target.attrs), newAttrs);
        },
    },
});
export var insertBefore = (_a = astSlice.actions, _a.insertBefore), insertAfter = _a.insertAfter, appendChildren = _a.appendChildren, removeById = _a.removeById, moveByPath = _a.moveByPath, setNodeAttrs = _a.setNodeAttrs;
